import { Box, Container, Text, Image, Stack, Heading } from '@chakra-ui/react';
import { ReactElement, useEffect, useState } from 'react';
import Slider from 'components/logos-sliders';
import AppConsts from '../../libs/appconst';
import BannerService from '../../services/banners/banner-service';
import { useNavigate } from 'react-router-dom';
import AuthorService from '../../services/authors/author-service';

const settings = {
    dots: true,
    centerMode: true,
    infinite: true,
    slidesToShow: 2,
    slidesToScroll: 1,
    autoplay: true,
    speed: 1000,
    autoplaySpeed: 3000,
    cssEase: "linear",
    centerPadding: "20%",
    responsive: [
        {
            breakpoint: 1920,
            settings: {
                infinite: true,
                centerPadding: "10%",
                slidesToShow: 2,
            }
        },
        {
            breakpoint: 1024,
            settings: {
                infinite: true,
                centerPadding: "10%",
                slidesToShow: 1,
            }
        },
        {
            breakpoint: 600,
            settings: {
                centerMode: false,
                centerPadding: "20%",
                slidesToShow: 1,
            }
        }
    ]
};

var settingSliderAuthor = {
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    speed: 500,
    autoplaySpeed: 4000,
    centerMode: true,
    arrows: false,
    responsive: [
        {
            breakpoint: 1024,
            settings: {
                centerMode: true,
                infinite: true,
                slidesToShow: 3,
                slidesToScroll: 2,
                centerPadding: "3%"
            }
        },
        {
            breakpoint: 600,
            settings: {
                centerMode: true,
                slidesToShow: 2,
                slidesToScroll: 1,
                centerPadding: "0%"
            }
        }
    ]
};

const WhatNew = (): ReactElement => {
    const navigate = useNavigate();
    const [isLoading, setLoading] = useState<boolean>(true);
    const [banners, setBanners] = useState<any>([]);
    const [authors, setAuthors] = useState<any>([]);

    useEffect(() => {
        setLoading(true);
        BannerService.GetAllShownBanner().then((res: any) => {
            setBanners(res.result);

            AuthorService.GetAll().then((resAuthor: any) => {
                setAuthors(resAuthor.result);
                if (resAuthor.result.length < 4) {
                    settingSliderAuthor.slidesToShow = resAuthor.result.length;
                }
            }).finally(() => {
                setLoading(false);
            });
        });
    }, []);

    return (
        <Box my={24}>
            <Container maxWidth={"8xl"} mb={12} mt={20}>
                <Text fontSize={{ base: '2xl', md: '4xl' }} align={'center'} lineHeight={'normal'} fontWeight={"extrabold"} color={'blackAlpha.800'}>Yang baru di {AppConsts.APP_NAME}</Text>
            </Container>

            <Slider height={'auto'} options={settings} arrows={true}>
                {
                    banners.map((banner: any) => (
                        <Box
                            px={3}
                            key={banner.id}
                            cursor={'pointer'}
                            onClick={() => banner.isRedirectToNewWindow ? window.open(banner.checkoutUrl) : window.location.href = banner.checkoutUrl}>
                            <Box
                                height={{ base: '3xs', lg: '380px', md: 'xs', sm: '3xs' }}
                                position="relative"
                                backgroundPosition="center"
                                backgroundRepeat="no-repeat"
                                backgroundSize="cover"
                                backgroundImage={`url(${banner.bannerUrl})`}
                                rounded={'xl'}
                                shadow={"md"}
                            />
                        </Box>
                    ))}
            </Slider>

            <Container maxWidth={"5xl"} mb={4}>
                <Slider options={settingSliderAuthor} arrows={false}>
                    {
                        authors.map(({ id, name, shortBioData, imageUrl }: any) => {
                            return (
                                <Box
                                    key={id}
                                    px={1}
                                >
                                    <Box
                                        maxW={'350px'}
                                        w={'full'}
                                        //bg={useColorModeValue('white', 'gray.900')}
                                        bg={'white'}
                                        boxShadow={'md'}
                                        rounded={'md'}
                                        overflow={'hidden'}>
                                        <Box bg={'gray.100'} mt={-10} mx={-6} pos={'relative'}>
                                            <Image src={imageUrl} />
                                        </Box>
                                        <Stack mt={'-70px'} pt={'10px'} pb={'8px'} position={'relative'} rowGap={0} textAlign={'center'} __css={{ background: 'linear-gradient(to bottom, rgba(255,0,0,0), rgb(0 0 0))' }}>
                                            <Heading
                                                //color={useColorModeValue('gray.700', 'white')}
                                                color={'whiteAlpha.900'}
                                                fontSize={{ base: 'sm', md: 'md' }}
                                                fontFamily={'body'}
                                            >
                                                {name}
                                            </Heading>
                                            <Text color={'whiteAlpha.800'}
                                                fontSize={{ base: 'xs', md: 'xs' }}
                                                mt={'0px'}>
                                                {shortBioData}
                                            </Text>
                                        </Stack>
                                    </Box>
                                </Box>
                            )
                        })
                    }
                </Slider>
            </Container>
        </Box>
    );
};

export default WhatNew;